export default __webpack_public_path__ + "static/zenith-6-5984446a58229117bf1d52e2d522eca5.jpg";